module.exports = __webpack_public_path__ + "img/gi.6c477041.svg";